(function(){
    var sec = document.currentScript.previousElementSibling;
    while (sec && !(sec.classList && sec.classList.contains('tp-koh'))) { sec = sec.previousElementSibling; }
    if (!sec) return;
    var btns = sec.querySelectorAll('[data-open-talki]');
    var sel = sec.getAttribute('data-widget-selector') || '';
    function openWidget(e){
      if (e && e.preventDefault) e.preventDefault();
      var ok = false;
      if (sel) { try { var el = document.querySelector(sel); if (el) { el.click(); ok = true; } } catch(err){} }
      if (!ok) {
        var guesses = ['#talki-launcher','.talki-launcher','[data-talki-launcher]','#chat-widget-launcher','.chat-launcher'];
        for (var i=0;i<guesses.length;i++){ var g = document.querySelector(guesses[i]); if (g) { try { g.click(); ok = true; break; } catch(err){} } }
      }
      if (!ok && typeof window.openTalki === 'function') { try { window.openTalki(); ok = true; } catch(err){} }
      if (!ok) { var f = document.getElementById('kontaktformular'); if (f) { f.scrollIntoView({behavior:'smooth'}); } }
    }
    for (var b = 0; b < btns.length; b++) { btns[b].addEventListener('click', openWidget); }
  })();
